import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from './components/core/dashboard/dashboard.component';
import {HelpComponent} from './components/core/help/help.component';
import {AboutComponent} from './components/core/about/about.component';
import {SpeechComponent} from './components/core/speech/speech.component';
import {OpencvComponent} from './components/core/opencv/opencv.component';
import {SpeechToTextComponent} from './components/core/speech-to-text/speech-to-text.component';
import {SemanticsComponent} from './components/core/semantics/semantics.component';
import {FaceapiComponent} from './components/core/faceapi/faceapi.component';
import {
  FaceLandmarkDetectionComponent
} from './components/core/faceapi/face-landmark-detection/face-landmark-detection.component';
import {
  FaceExpressionDetectionComponent
} from './components/core/faceapi/face-expression-detection/face-expression-detection.component';
import {
  FaceAgeGenderDetectionComponent
} from './components/core/faceapi/face-age-gender-detection/face-age-gender-detection.component';
import {FaceDetectionComponent} from './components/core/faceapi/face-detection/face-detection.component';


const routes: Routes = [
  /* Public Area */
  {
    path: '',
    component: DashboardComponent
  },
  {
    path: 'face-api',
    component: FaceapiComponent,
    children: [
      {
        path: '',
        redirectTo: 'face-expression',
        pathMatch: 'full'
      },
      {
        path: 'face',
        component: FaceDetectionComponent
      },
      {
        path: 'face-landmark',
        component: FaceLandmarkDetectionComponent
      },
      {
        path: 'face-expression',
        component: FaceExpressionDetectionComponent
      },
      {
        path: 'age-gender',
        component: FaceAgeGenderDetectionComponent
      }
    ]
  },
  {
    path: 'object-detection',
    component: OpencvComponent
  },
  {
    path: 'speech',
    component: SpeechComponent
  },
  {
    path: 'speech-to-text',
    component: SpeechToTextComponent
  },
  {
    path: 'semantics',
    component: SemanticsComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'help',
    component: HelpComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
